import { SchedulingDto } from './ms_scheduling_dto';

// ----- Main DTO -----
export class RecurrenceDto {
  pattern: {
    type: MsRecurrencePattern;
    daysOfWeek?: DayOfWeek[];
    dayOfMonth?: DayOfMonth;
    firstDayOfWeek?: string;
    index?: IndexOfWeek;
    interval: number;
    month?: number;
  };
  range: {
    numberOfOccurrences?: number;
    recurrenceTimeZone: string;
    startDate: string;
    endDate?: string;
    type: RangeType;
  };

  constructor(dto?: SchedulingDto | RecurrenceDto) {
    let range = { recurrenceTimeZone: 'America/Sao_Paulo'}, pattern = {};

    if (dto && dto instanceof SchedulingDto) {
      pattern = dto.recurrence.pattern;
      range = dto.recurrence.range;
    }

    if (dto && dto instanceof RecurrenceDto) {
      pattern = dto.pattern;
      range = dto.range;
    }

    // 'any' ensure compatibility, MS API don't accept null
    this.pattern = pattern as any;
    this.range = range as any;
  }
}

// ----- Enums / Constants as objects -----
export const msRecurrencePattern = {
  RelativeYearly: 'relativeYearly',
  AbsoluteYearly: 'absoluteYearly',
  RelativeMonthly: 'relativeMonthly',
  AbsoluteMonthly: 'absoluteMonthly',
  Weekly: 'weekly', Daily: 'daily',
} as any;

export const DayOfWeekMap = {
  Sunday: 'sunday',
  Monday: 'monday',
  Tuesday: 'tuesday',
  Wednesday: 'wednesday',
  Thursday: 'thursday',
  Friday: 'friday',
  Saturday: 'saturday',
} as any;

export const IndexOfWeekMap = {
  First: 'first',
  Second: 'second',
  Third: 'third',
  Fourth: 'fourth',
  Last: 'last',
} as any;

export const MonthIndexMap = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
} as any;

export const RangeTypeMap = {
  numbered: 'numbered',
  end_date: 'endDate',
  no_end: 'noEnd',
} as any;

// -----  Derived types -----
export type DayOfWeek = typeof DayOfWeekMap[keyof typeof DayOfWeekMap];
export type RangeType = typeof RangeTypeMap[keyof typeof RangeTypeMap];
export type DayOfMonth = typeof MonthIndexMap[keyof typeof MonthIndexMap];
export type IndexOfWeek = typeof IndexOfWeekMap[keyof typeof IndexOfWeekMap];
export type MsRecurrencePattern = typeof msRecurrencePattern[keyof typeof msRecurrencePattern];

// ----- Options for the component (e.g., p-dropdown) -----
export const monthOptions = Object.entries(MonthIndexMap).map(([label, value]) => ({ label, value, }));
export const rangeTypeOptions = Object.entries(RangeTypeMap).map(([label, value]) => ({ label, value, }));
export const dayOfWeekOptions = Object.entries(DayOfWeekMap).map(([label, value]) => ({ label, value, }));
export const indexOfWeekOptions = Object.entries(IndexOfWeekMap).map(([label, value]) => ({ label, value, }));
export const recurrenceOptions = Object.entries(msRecurrencePattern).map(([label, value]) => ({ label, value, }));

// ----- Grouped export for use in forms with a single var -----
export const msRecurrenceOptions = {
  indexOfWeekOptions,
  recurrenceOptions,
  dayOfWeekOptions,
  rangeTypeOptions,
  monthOptions,
};



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/ms_recurrence.ts